<template>
  <div class="wip">
    <el-container>
      <el-header>
        <h2 class="card-title">WIP</h2>
        <el-switch
          class="pull-right center"
          v-model="isProspect"
          active-color="#409eff"
          inactive-color="#409eff"
          active-text="Prospect"
          inactive-text="Current">
        </el-switch>
      </el-header>
      <el-main class="panels">
        <project-list-table
          :isProspect = "isProspect" 
          :projects="openProjects"
          :activeUsers="activeUsers">
        </project-list-table>
          <div class="panel list-panel" v-if="!activeUsers.length">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span><b>No Users Selected</b></span>
              </div>
            </el-card>
          </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: 'wip',
    data () {
      return {
        userFilter: [],
        showTable: false,
        isProspect: false
      }
    },
    computed: {
      // Vuex Mappings
      users () {
        return this.$store.state.users.objects
      },
      activeUsers () {
        return Object.keys(this.users)
          .map((k) => this.users[k])
          .filter((k)=> k.status === 1)
          .sort((a, b) => {
            //Sort users alphabetically (ascending)
            return a.first_name > b.first_name ? 1 : -1
          })
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      openProjects () {
        return Object.keys(this.$store.state.projects.objects)
          .map((k) => this.$store.state.projects.objects[k])
          .filter((k) => k.status)
          .sort((a, b) => {
            // Sort by most recent first
            return a.id < b.id ? 1 : -1
          })
      }
    },
    mounted () {
      // Note: Intentionally not calling store.getUsers as this is handled on load in App.vue
      // and Pusher should take care of live-updates to users
      this.$store.dispatch('setPageTitle', 'WIP')

      // Delay the API requests to speed up rendering
      setTimeout(function () {
        for (let i in this.users) {
          if (this.users[i].status === 1) {
            this.$store.dispatch('getTasks', { user_id: this.users[i].id })
          }
        }
      }.bind(this), 1000)
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .wip {
    .user-filter {
      margin-left: 20px;
      display: inline-block;
      line-height: 1;
      vertical-align: middle;
    }
    .pull-right.center {
      position: relative;
      bottom: -40%;
      &::after {
        content: "";
        clear: both;
      }
      .tasks {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }
    }
    .isDisabled {
      opacity: 0.55;
      cursor: not-allowed;
    }
    .isDisabled label>input+span:nth-of-type(n) {
      cursor: not-allowed;
      color: inherit
    }
  }
</style>
